export enum UserDataSource {
    boiSignup = 'BOI_onsite_signup',
    legSignup = 'LK_onsite_signup_form', // most like to be changed
}
